import { FunctionComponent } from 'react';
import { FormField, FormFieldProps } from '../form-field';
import { Input, InputProps } from 'antd';
import classNames from 'classnames';
import { useResponsiveness } from '@monorepo/react-hooks';

const { OTP } = Input;

export const FormOtp: FunctionComponent<
  Omit<FormFieldProps, 'render'> & { props?: InputProps } & {
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  }
> = (formFieldProps) => {
  const { isMobile } = useResponsiveness();

  return (
    <FormField
      {...formFieldProps}
      className={classNames({
        'form-field__otp': !isMobile,
      })}
      render={({ field: { onChange, ...rest } }) => {
        return (
          <OTP
            size="large"
            {...rest}
            onInput={(e) => {
              const text = e.join('');

              onChange(text);
            }}
            onKeyDown={formFieldProps?.onKeyDown}
          />
        );
      }}
    />
  );
};
